<template>
	<div class="my-bookmark__slide__panel" :style="style">
		<ul class="my-bookmark__tag-list">
			<tag-item v-for="tag in tagList" @tag-select="onTagSelect" :tag="tag" :focused="focused"></tag-item>
			<li v-if="page+1 === maxPage && page % 2"></li>
		</ul>
	</div>
</template>

<script>
	import TagItem from './TagItem.vue';

	export default {
		components: { TagItem },

		props: ['tagList', 'focused', 'page', 'maxPage'],
		computed: {
			style: function () {
				return {
					width: (100 / this.maxPage) + '%'
				};
			}
		},

		methods: {
			onTagSelect: function (id) {
				this.$emit('tag-select', id);
			}
		}
	}
</script>
